import { createSvgIcon } from "./create-svg-icon";

export const ArrowDownAction = createSvgIcon(
  <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.0453181 0.214407C-0.0232706 0.34627 -0.013423 0.505232 0.070919 0.62762L3.67111 5.82779C3.74583 5.93565 3.86871 6 3.99992 6C4.13114 6 4.25402 5.93565 4.32874 5.82779L7.92893 0.62762C8.01357 0.505306 8.02334 0.346133 7.95432 0.214379C7.88529 0.0826251 7.74886 5.02026e-05 7.60011 5.46004e-09L0.399736 5.46004e-09C0.25091 -2.45198e-05 0.114374 0.0825737 0.0453181 0.214407Z"
      fill="currentColor"
    />
  </svg>,
);
